import { useEffect } from 'react'

import { useCommentsStore } from '../stores/comments.store'

export const useComments = () => {
  const removeExpiredReadNotifications = useCommentsStore(
    (state) => state.removeExpiredReadNotifications,
  )

  useEffect(() => {
    // Remove anything already expired
    removeExpiredReadNotifications()

    // Check every minute
    const interval = setInterval(() => {
      removeExpiredReadNotifications()
    }, 60 * 1000)

    return () => clearInterval(interval)
  }, [removeExpiredReadNotifications])

  return useCommentsStore()
}
